import { Info } from "components/icons/Info";
import { CallSummary } from "store/apis/chat";
import { CallSummaryMarkdown } from "./CallSummaryMarkdown";

export const CallSummaryNote = ({
  summary,
}: {
  summary: CallSummary | null;
}) => {
  if (!summary?.is_success) return null;

  return (
    <div className="t-flex t-gap-2 t-items-start">
      <span className="t-flex t-shrink-0 t-mt-0.5 t-text-text-30">
        <Info color="currentColor" stroke="1.2" size="16" />
      </span>
      <div className="t-space-y-1">
        <p className="t-text-body-sm t-text-text-30 t-mb-0 t-italic">
          This summary is AI-generated and may contain inaccuracies. Please
          verify important details before acting on them.
        </p>
        <CallSummaryMarkdown text={summary.summary} />
      </div>
    </div>
  );
};
